/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ResetEmailDialog.vue?vue&type=template&id=4c0b4354&scoped=true"
import script from "./ResetEmailDialog.vue?vue&type=script&lang=js"
export * from "./ResetEmailDialog.vue?vue&type=script&lang=js"
import style0 from "./ResetEmailDialog.vue?vue&type=style&index=0&id=4c0b4354&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0b4354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c0b4354')) {
      api.createRecord('4c0b4354', component.options)
    } else {
      api.reload('4c0b4354', component.options)
    }
    module.hot.accept("./ResetEmailDialog.vue?vue&type=template&id=4c0b4354&scoped=true", function () {
      api.rerender('4c0b4354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/ResetEmailDialog.vue"
export default component.exports